const styles = {
    modalContainer: {
        maxHeight: '90vh',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '75%',
        maxWidth: '1400px',
        backgroundColor: '#ffffff', // Fixed background color
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
        p: 3,
        borderRadius: '12px',
        overflow: 'auto',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 3,
    },
    headerTitle: {
        fontWeight: '400',
        fontSize: '1.23rem',
        marginBottom: 1,
    },
    closeButton: {
        position: 'absolute',
        right: 12,
        top: 12,
        color: '#666',
        '&:hover': {
            bgcolor: '#f5f5f5',
        }
    },
    creditInfo: {
        display: 'flex',
        gap: 6,
        mb: 3,
        flexWrap: 'wrap',
    },
    creditBox: {
        display: 'flex',
        alignItems: 'center',
        gap: 2,
    },
    creditIcon: {
        width: 40,
        height: 40,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&.note': {
            bgcolor: '#FC8F31',
            color: 'white',
        },
        '&.available': {
            bgcolor: '#6a8aaf',
            color: 'white',
        },
    },
    creditDetails: {
        '& .label': {
            color: '#888',
            fontSize: '0.875rem',
            fontWeight: 400,
            mb: 0.5,
        },
        '& .value': {
            fontWeight: 400,
            fontSize: '1rem',
            color: '#333',
        },
    },
    sectionHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 1.5, // 12px
    },
    sectionTitle: {
        fontWeight: '400',
        fontSize: '1.23rem',
        marginBottom: 1,
    },
    dateToggle: {
        display: 'flex',
        alignItems: 'center',
        gap: 1.25, // 10px
    },
    infoIcon: {
        backgroundColor: '#1a2247',
        color: '#fff',
        borderRadius: '50%',
        width: 18,
        height: 18,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 13,
        cursor: 'pointer',
        lineHeight: 1,
        ml: 0.5,
        '&:hover': {
            backgroundColor: '#2c3e50',
        },
    },
    tooltip: {
        bgcolor: '#1a2247',
        color: '#fff',
        fontSize: 14,
        borderRadius: 1,
        p: '10px 14px',
        maxWidth: 270,
    },
    tableContainer: {
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        overflow: 'auto',
        flex: '1 1 auto',
        maxHeight: 'calc(90vh - 400px)',
    },
    table: {
        '& .MuiTableHead-root': {
            bgcolor: '#fafafa',
        },
        '& .MuiTableCell-head': {
            fontWeight: 600,
            color: '#666',
            fontSize: '0.8rem',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            borderBottom: '2px solid #e0e0e0',
        },
        '& .MuiTableCell-body': {
            fontSize: '0.9rem',
            borderBottom: '1px solid #f0f0f0',
        },
        '& .MuiTableRow-root:last-child .MuiTableCell-body': {
            borderBottom: 'none',
        }
    },
    creditsInput: {
        '& .MuiOutlinedInput-root': {
            height: '36px',
            '& input': {
                textAlign: 'right',
                padding: '8px 12px',
                fontSize: '0.9rem',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#2196F3',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#2196F3',
            }
        }
    },
    summary: {
        display: 'flex',
        flexDirection: 'column',
        // justifyContent: 'flex-end',
        gap: 2,
        mt: 3,
        pt: 3,
        borderTop: '2px solid #f0f0f0',
        '& > div': {
            display: 'flex',
            gap: 2,
            justifyContent: 'flex-end',   // align label and value together on the right
            alignItems: 'flex-end',
            minWidth: '160px',
        },
        '& .label': {
            color: '#666',
            fontSize: '0.9rem',
            mb: 0.5,
        },
        '& .value': {
            fontWeight: 600,
            fontSize: '1.1rem',
            color: '#333',
        },
    },
    actions: {
        display: 'flex',
        justifyContent: 'flex-start',
        gap: 2,
        mt: 4,
    },
    createJob: {
        textAlign: "center",
    },
    jobButtons: {
        borderRadius: 50,
        textTransform: "none",
        backgroundColor: "#28AA4A",
        fontSize: "14px",
        fontWeight: "500",
        px: 4,
        " & .css-1yt7yx7-MuiLoadingButton-loadingIndicator": {
            position: "unset",
        },
        "& .MuiButton-startIcon": {
            marginRight: "8px",
            marginLeft: "-8px",
        },

    },
};

export default styles;


